// Infinite Scroll for Shopify Collection Pages

(function() {
  console.log('[InfiniteScroll] Script loaded');
  const productGrid = document.querySelector('#product-grid');
  const pagination = document.querySelector('.pagination-wrapper');
  const sectionId = 'main-collection-product-grid'; // Use your section ID here
  if (!productGrid) {
    console.log('[InfiniteScroll] #product-grid not found');
    return;
  }
  if (!pagination) {
    console.log('[InfiniteScroll] .pagination-wrapper not found');
    return;
  }
  pagination.classList.add('visually-hidden-pagination'); // Visually hide pagination

  let sentinel = document.getElementById('infinite-scroll-sentinel');
  let loadingSpinner = document.getElementById('infinite-scroll-loading');

  if (!sentinel) {
    console.log('[InfiniteScroll] #infinite-scroll-sentinel not found');
  } else {
    console.log('[InfiniteScroll] #infinite-scroll-sentinel found');
  }
  if (!loadingSpinner) {
    console.log('[InfiniteScroll] #infinite-scroll-loading not found');
  } else {
    console.log('[InfiniteScroll] #infinite-scroll-loading found');
  }

  let loading = false;
  let nextPage = getNextPage();
  let observer;

  function getNextPage() {
    const nextLink = pagination.querySelector('a[rel="next"]');
    if (nextLink) {
      console.log('[InfiniteScroll] Next page URL:', nextLink.href);
    } else {
      console.log('[InfiniteScroll] No next page link found');
    }
    return nextLink ? nextLink.href : null;
  }

  function showLoading() {
    if (loadingSpinner) loadingSpinner.style.display = 'block';
    console.log('[InfiniteScroll] Show loading spinner');
  }
  function hideLoading() {
    if (loadingSpinner) loadingSpinner.style.display = 'none';
    console.log('[InfiniteScroll] Hide loading spinner');
  }

  function moveSentinelToEnd() {
    // Remove old sentinel if it exists
    let oldSentinel = document.getElementById('infinite-scroll-sentinel');
    if (oldSentinel) {
      oldSentinel.remove();
    }
    // Create new sentinel <li> and append to end of product grid
    const newSentinel = document.createElement('li');
    newSentinel.id = 'infinite-scroll-sentinel';
    newSentinel.style.height = '40px';
    newSentinel.style.background = 'red';
    newSentinel.style.display = 'block';
    productGrid.appendChild(newSentinel);
    return newSentinel;
  }

  function observeSentinel(sentinelElement) {
    if (observer) observer.disconnect();
    observer = new window.IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting && nextPage && !loading) {
          console.log('[InfiniteScroll] Sentinel intersected, loading next page');
          loadNextPage();
        }
      });
    }, { rootMargin: '200px' });
    observer.observe(sentinelElement);
    console.log('[InfiniteScroll] Observer attached to sentinel');
  }

  function loadNextPage() {
    if (!nextPage || loading) return;
    loading = true;
    showLoading();
    // Use Section Rendering API
    const url = new URL(nextPage, window.location.origin);
    url.searchParams.set('section_id', sectionId);
    console.log('[InfiniteScroll] Fetching:', url.toString());
    fetch(url.toString())
      .then(res => res.text())
      .then(html => {
        // Parse the returned section HTML
        const doc = new DOMParser().parseFromString(html, 'text/html');
        // Find the new product grid in the returned section
        const newGrid = doc.querySelector('#product-grid');
        if (newGrid) {
          // Only append <li class="grid__item">
          const newItems = Array.from(newGrid.querySelectorAll('li.grid__item'));
          newItems.forEach(item => productGrid.appendChild(item));
          console.log(`[InfiniteScroll] Appended ${newItems.length} new products`);
        } else {
          console.log('[InfiniteScroll] No #product-grid found in fetched HTML');
        }
        // Update pagination
        const newPagination = doc.querySelector('.pagination-wrapper');
        if (newPagination) {
          pagination.innerHTML = newPagination.innerHTML;
          nextPage = getNextPage();
        } else {
          pagination.remove();
          nextPage = null;
          console.log('[InfiniteScroll] No more pages');
        }
        // Move sentinel to end and re-observe
        sentinel = moveSentinelToEnd();
        observeSentinel(sentinel);
      })
      .catch((err) => {
        console.log('[InfiniteScroll] Fetch error:', err);
      })
      .finally(() => {
        loading = false;
        hideLoading();
      });
  }

  // Initial observer setup
  sentinel = moveSentinelToEnd();
  observeSentinel(sentinel);

})(); 